export default __webpack_public_path__ + "static/service-3-c72d3b94a488c8190bd0b6a27d840d6f.jpg";